import { Empty } from "antd";
import { ConfigProvider } from "antd";

function EmptyPage() {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorTextDescription: "rgb(202, 176, 176)"
                }
            }}
        >
            <div style={{marginTop: "100px", height: "300px"}}>
                <Empty description="404 Not Found"></Empty>
            </div>
        </ConfigProvider>
    );
}

export default EmptyPage;